export default __webpack_public_path__ + "static/media/box-read-more.9578bc3e.png";